import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '1rem',
  },
})

export default useStyles
